<template>
  <div>
    <BaseLoading v-if="isAthletesEventLoading" />
    <template v-else-if="athletesEvent.length">
      <b-row>
        <b-col
          v-for="event in athletesEvent"
          :key="event.id"
          :cols="12"
        >
          <TheMatchGifHighlight
            :poster="event.image_url"
            :webm-url="event.video_webm_url"
            :mp4-url="event.video_mp4_url"
            :team1-image="event.match.team1.image_url"
            :team1-name="event.match.team1.display_name[$i18n.locale]"
            :team2-image="event.match.team2.image_url"
            :team2-name="event.match.team2.display_name[$i18n.locale]"
            :is-performance="!! event.performance"
            :athlete-name="event.performance && event.performance.athlete.name[$i18n.locale]"
            :performance-category-name="event.performance && event.performance.category.name"
            :time="event.time"
          />
        </b-col>
      </b-row>
    </template>
    <BaseAlert v-else>
      {{ $t('no-highlights-available-in-this-round-yet') }}
    </BaseAlert>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseLoading from '@/components/Atoms/BaseLoading'
import BaseAlert from '@/components/Atoms/BaseAlert'
import TheMatchGifHighlight from '@/components/Molecules/TheMatchGifHighlight'

export default {
  name: 'RoundDetailHighlights',
  components: {
    TheMatchGifHighlight,
    BaseAlert,
    BaseLoading,
  },
  data() {
    return {
      roundId: this.$route.params.roundId,
    }
  },
  computed: {
    ...mapState({
      isAthletesEventLoading: state => state['rounds/athletesEvents'].isAthletesEventLoading,
      athletesEvent: state => state['rounds/athletesEvents'].athletesEvent,
    }),
  },
  created() {
    this.fetchAthletesEvent({ roundId: this.roundId })
  },
  methods: {
    ...mapActions({
      fetchAthletesEvent: 'rounds/athletesEvents/fetchAthletesEvent',
    }),
  },
}
</script>
